import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { applicationRouteNames } from '../../app/application-route-names';
import { MpsUser } from '../../app/models/mps-user.model';
import { MpsUserService } from '../services/mps-user.service';

/**
 * Autorise l'accès aux écrans "données de filiale" (contacts, abonnements, signalements)
 * pour les administrateurs globaux ET les administrateurs de filiale.
 */
export const MpsSubsidiaryDataGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.navigateByUrl(applicationRouteNames.home);
  }

  const user = new MpsUser(loggedInUser);
  return user.isAdmin() || user.isSubsidiaryAdmin() ? true : router.navigateByUrl(applicationRouteNames.home);
};
